<template lang="pug">
.select_options(
  :class='{ onlyBox: select.onlyBox, disabled: disabled, readonly: readonly, noCheckBox: !select.showCheckBox, checked: checked, d_row: select.direction !== "column" }',
  @click.stop.prevent='handleClick'
)
  slot
    .option_warp
      span(v-if='select.showCheckBox')
        i.select-box.icon(v-show='!checked')
        i.select-box.icon.checked(v-show='checked')
      slot(name='label')
        span.contentLabel {{ label || value }}
</template>

<script>
import emitter from '../../src/mixins/emitter.js'
export default {
  name: 'km-select-option',
  inject: ['select'],
  mixins: [emitter],
  props: {
    disabled: {
      default: false,
    },
    value: {
      required: true,
    },
    label: '',
    readonly: {
      default: false,
    },
  },
  data() {
    return {
      isByClick: false,
    }
  },
  methods: {
    handleClick(e) {
      if (!this.disabled && !this.readonly) {
        if (this.select.onlyBox && !e.target.classList.contains('select-box')) return
        this.isByClick = true
        this.dispatch('kmSelect', 'select', [this, !this.checked])
      }
    },
    contains(arr = [], value) {
      if (this.select.multiple && arr instanceof Array) {
        return arr.includes(value)
      }
      return this.select.value === value
    },
  },
  computed: {
    checked(value) {
      return !this.disabled && this.contains(this.select.value, this.value)
    },
  },
  watch: {
    checked: {
      immediate: true,
      handler() {
        if (this.isByClick) {
          this.isByClick = false
        } else {
          this.dispatch('kmSelect', 'select', [this, this.checked])
        }
      },
    },
    value(v, old) {
      if (this.contains(this.select.value, old)) {
        this.dispatch('kmSelect', 'deleteSelect', [this])
      }
    },
  },
  beforeDestroy() {
    if (this.checked) {
      this.dispatch('kmSelect', 'deleteSelect', [this])
    }
  },
}
</script>

<style lang="less" scoped>
.select_options {
  cursor: pointer;
  padding-left: 10px;
  line-height: 24px;
}
i.icon {
  display: block;
  width: 16px;
  height: 16px;
  background-image: url(/static/images/icon_common.png);
}
i.icon.checked {
  background-position-x: -16px;
}
.d_row {
  display: inline-block;
  padding: 0 6px;
  color: #21bd73;
  margin-left: 4px;
  margin-right: 4px;
}
.disabled,
.readonly {
  cursor: not-allowed;
  color: #aaa;
  * {
    cursor: not-allowed;
    color: #aaa;
  }
}
.noCheckBox:hover {
  background: #f2f9f6;
}
.noCheckBox.checked {
  background: #24cc7c;
  color: white;
}
.option_warp {
  display: flex;
  align-items: center;
}
.contentLabel {
  margin-left: 6px;
  line-height: 20px;
}
.onlyBox.select_options {
  cursor: default;
  * {
    cursor: default;
  }
}
.onlyBox i.select-box{
  cursor: pointer;
}
.onlyBox.disabled i.select-box,
.onlyBox.readonly  i.select-box{
  cursor: not-allowed;
  color: #aaa;
  background-image: url('../../image/noSelectDisabled.png');
  background-position-x: 0px;
  background-size: cover;
}
.onlyBox.readonly i.select-box.checked{
  background-image: url('../../image/selectDisabled.png');
}
</style>



// WEBPACK FOOTER //
// src/ui/components/km-select/select-option.vue